import React, { FC, SVGProps } from 'react';

export const CaretDown: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.8564 9.05109H4.16609C2.68983 9.05109 1.93453 10.7862 2.99881 11.7873L6.84397 15.5245C7.46194 16.1585 8.52622 16.1585 9.17852 15.5245L13.0237 11.7873C14.0536 10.7862 13.2983 9.05109 11.8564 9.05109ZM4.16609 6.91554H11.8221C13.2983 6.91554 14.0536 5.21376 12.9893 4.21272L9.14419 0.475495C8.52622 -0.158498 7.46194 -0.158498 6.84397 0.475495L2.99881 4.21272C1.96886 5.21376 2.68983 6.91554 4.16609 6.91554ZM8.01124 1.57664L11.8564 5.31387H4.16609L8.01124 1.57664Z"
      fill="grey"
    />
  </svg>
);
